import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";

const Home = lazy(() => import("./pages/Home"));
const Slagbomen = lazy(() => import("./pages/Slagbomen"));
const Toegang = lazy(() => import("./pages/Toegangsoplossingen"));
const Sectoren = lazy(() => import("./pages/Sectoren"));
const SectorDetail = lazy(() => import("./pages/SectorDetail"));
const Werkwijze = lazy(() => import("./pages/Werkwijze"));
const Onderhoud = lazy(() => import("./pages/Onderhoud"));
const Configurator = lazy(() => import("./pages/Configurator"));
const Offerte = lazy(() => import("./pages/Offerte"));
const Faq = lazy(() => import("./pages/Faq"));
const Kennisbank = lazy(() => import("./pages/Kennisbank"));
const Artikel = lazy(() => import("./pages/Artikel"));
const Contact = lazy(() => import("./pages/Contact"));
const Legal = lazy(() => import("./pages/Legal"));
const Bedankt = lazy(() => import("./pages/Bedankt"));
const NotFound = lazy(() => import("./pages/NotFound"));

const Loader = () => (
  <div className="flex min-h-[60vh] items-center justify-center bg-obsidian">
    <div className="font-label text-xs text-titanium animate-pulse">SLAGBOOM EXPERT — LADEN</div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#0E1419", border: "1px solid rgba(174,184,192,0.2)", color: "#F4F7F9", borderRadius: 0 } }} />
      <Layout>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/slagbomen" element={<Slagbomen />} />
            <Route path="/toegangsoplossingen" element={<Toegang />} />
            <Route path="/sectoren" element={<Sectoren />} />
            <Route path="/sectoren/:slug" element={<SectorDetail />} />
            <Route path="/werkwijze" element={<Werkwijze />} />
            <Route path="/onderhoud" element={<Onderhoud />} />
            <Route path="/configurator" element={<Configurator />} />
            <Route path="/offerte" element={<Offerte />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/kennisbank" element={<Kennisbank />} />
            <Route path="/kennisbank/:slug" element={<Artikel />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Legal page="privacy" />} />
            <Route path="/privacy-anpr" element={<Legal page="privacy-anpr" />} />
            <Route path="/cookies" element={<Legal page="cookies" />} />
            <Route path="/disclaimer" element={<Legal page="disclaimer" />} />
            <Route path="/bedankt" element={<Bedankt />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
